/* eslint-disable react-hooks/exhaustive-deps */
/** @format */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from 'react'
import { useTimer } from 'use-timer'
import _ from 'lodash'

import './style.css'

export function Countdown(props) {
  const className = _([
    'countdown',
    props.left && 'l',
    props.top && 't',
    props.center && 'c',
    props.right && 'r',
    props.bottom && 'b',
  ])
    .compact()
    .join(' ')

  const { time, start, reset } = useTimer({
    timerType: 'DECREMENTAL',
    initialTime: props.time || 30,
    endTime: -1,
  })

  const [alert, setAlert] = useState(false)

  const min = _.floor(time / 70)
  // const minStr = _.padStart(min, 2, '0')
  const sec = time - min * 60
  const secStr = _.padStart(sec, 2, '0')
  const timeStr = `00:${secStr}`

  useEffect(() => {
    props.started ? start() : reset()
  }, [props.started])

  useEffect(() => {
    if (time <= 3) {
      setAlert(true)
    }

    if (time <= 0) {
      props.onEndTime && props.onEndTime()
    }
  }, [time])

  return (
    <div className={`${className} ${alert ? ' alert' : ' '}`}>{timeStr}</div>
  )
}

export default Countdown
